<template>
  <div @click="imageModal = true">
    <img :src="food.imgurl" alt="" class="shadow-2xl" />
  </div>
  <div class="relative p-4" @click.stop>
    <h1 class="text-lg mt-4 text-center text-theme-500 font-bold">{{ food.kala_Name }}</h1>
    <!-- Order Buttons -->
    <div class="flex justify-center mt-4">
      <div class="flex bg-gray-200 rounded-full">
        <div class="flex bg-theme-500 rounded-full">
          <span class="p-2 px-4 font-bold text-base text-white" @click="incrementCount(this.food)"
            >+</span
          >
          <span class="m-1 p-1 px-3 bg-white text-theme-500 font-bold rounded-full">{{
            count(food.kala)
          }}</span>
          <span class="p-2 px-4 font-bold text-white" @click="decrementCount(this.food)"
            >-</span
          >
        </div>
        <span class="mr-2 p-2 text-ColorNerkh font-bold ml-2">{{
            $helper.priceFormatter(
              food.nerkh_With_Maliat_With_Detail / 10,
              false
            )
          }}</span>
      </div>
    </div>

    <!-- Description -->
    <h1 class="mt-4 text-theme-500">توضیحات</h1>
    <p class="text-sm text-justify text-theme-500 mt-2 leading-7">
      {{ food.fullDescription }}
    </p>

    <!-- Service -->
    <!-- <div v-if="food.hasService">
      <h1 class="mt-4">سرویس</h1>
      <div class="flex flex-wrap gap-y-6 text-center text-sm mt-4 text-gray-100">
        <div v-for="service in food.serviceTagList" :key="service">
          <span class="border border-brand rounded-md p-1 mx-2">{{
            service
          }}</span>
        </div>
      </div>
    </div> -->

    <!-- Cook Mode -->
    <div class="flex justify-between items-center mt-6" v-if="food.isTag">
      <h1 class="">نوع طبخ</h1>
      <div class="flex text-sm">
        <div class="border border-theme-500 rounded-lg p-2 bg-brand">نرمال</div>
        <div class="border border-theme-500 rounded-lg p-2 mr-2">پخت متوسط</div>
        <div class="border border-theme-500 rounded-lg p-2 mr-2">کاملا پخته</div>
      </div>
    </div>
    <hr class="border-theme-500 my-4" />
    <!-- Total Price -->
    <div class="flex justify-between">
      <h1 class="text-theme-500">جمع (با مالیات)</h1>
      <span class="text-ColorNerkh font-bold">
        {{
          $helper.priceFormatter(
            Math.trunc(
              count(food.kala) * food.nerkh +
                count(food.kala) * food.nerkh * (food.afzodeAvarez / 100)
            ) / 10
          )
        }}
      </span>
    </div>
    <VButton class="w-full  border border-theme-500 mt-8 text-theme-500 font-bold shadow-lg" @click="getMenuOnlyService()">
      انتخاب سرویس
    </VButton>
    <!-- <router-link to="/menu" class="mb-10">
      <VButton class="w-full mt-2 text-gray-100"> ادامه </VButton>
    </router-link> -->
  </div>

  <!-- Image Modal -->
  <transition name="fade">
    <div
      class="fixed flex items-center top-0 bg-gray-500/50 w-screen h-screen p-2"
      v-if="imageModal"
      @click="imageModal = !imageModal"
    >
      <img
        :src="food.imgurl"
        alt=""
        class="rounded-lg"
        @error="
          $event.target.src = require('@/assets/img/food_placeholder.png')
        "
      />
    </div>
  </transition>

  <div
    class="absolute w-full h-full top-0 bg-gray-500/50 flex items-center justify-center"
    v-if="loading"
  >
    <LoadingSpinner class="w-10 h-10" />
  </div>

  <transition name="fade">
    <div
      class="fixed h-screen w-screen top-0 bg-gray-500/50 z-30"
      v-if="modalService"
      @click="notShow()"
    >
      <div
        class="bg-white rounded-lg w-screen mt-[40%] mx-auto p-4"
        @click.stop
      >
        <h1 class="text-center">انتخاب سرویس</h1>
        <hr class="border-theme-500 my-4" />
        <form action="" class="overflow-y-scroll flex flex-col h-96">
          <div
            class="flex items-center flex-col mt-2"
            v-for="serv in this.kala"
            :key="serv.kala"
          >
            <div
              class="flex flex-row justify-between border border-theme-500 p-4 rounded-lg mb-2 w-full"
            >
              <span class="text-sm">{{ serv.kala_Name }}</span>
              <span>{{
                $helper.priceFormatter(
                  (serv.nerkh + serv.nerkh * (serv.afzodeAvarez / 100)) / 10,
                  false
                )
              }}</span>
              <div class="flex bg-brand rounded-full">
                <span class="p-1 px-2 font-bold" @click="incrementCount(serv)"
                  >+</span
                >
                <span class="p-1 px-1 bg-white rounded-full">{{
                  count(serv.kala)
                }}</span>
                <span class="p-1 px-2 font-bold" @click="decrementCount(serv)"
                  >-</span
                >
              </div>
            </div>
            <div>
              <span class="text-theme-500">
                {{
                  $helper.priceFormatter(
                    Math.trunc(
                      count(serv.kala) * serv.nerkh +
                        count(serv.kala) *
                          serv.nerkh *
                          (serv.afzodeAvarez / 100)
                    ) / 10
                  )
                }}
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { getFood, getMenuOnlyService } from "@/API/API";
import VButton from "@/components/General/VButton";
import LoadingSpinner from "@/components/General/LoadingSpinner";
//import { truncate } from "fs/promises";

export default {
  name: "FoodPage",
  components: { LoadingSpinner, VButton },
  data() {
    return {
      loading: true,
      imageModal: false,
      modalService: false,
      food: {},
      service: {},
      kala: {},
    };
  },
  computed: {
    count() {
      return (foodId) => this.$store.getters.productCount(foodId);
    },
  },
  async created() {
    this.food = (await getFood(this.$route.params.id)).data.result;
    this.loading = false;
  },
  methods: {
    incrementCount(food) {
      this.$store.dispatch("addProduct", food).catch((err) => {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: err,
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      });
    },
    decrementCount(food) {
      this.$store.dispatch("removeProduct", food);
    },
    async getMenuOnlyService() {
      this.service = (await getMenuOnlyService()).data.result;
      this.kala = this.service.products;
      this.modalService = true;
    },
    notShow() {
      this.modalService = false;
    },
  },
};
</script>

<style scoped>
.food_bg {
  background-image: url("../assets/img/pattern_bg_2.png");
}

.image-shadow {
  filter: drop-shadow(12px 12px 25px rgba(0, 0, 0, 0.5));
}
</style>
